import React from 'react';

import {
    ReCaptchaWithTitle as ReCaptchaWithTitleBare
} from '@interlayer/js/app/components/main/ReCaptchaWithTitle/ReCaptchaWithTitle';

import { TReCaptchaWithTitleProps } from '@interlayer/js/app/components/main/ReCaptchaWithTitle/types';

export const ReCaptchaWithTitle: React.FC<TReCaptchaWithTitleProps> = (props) => <ReCaptchaWithTitleBare theme="dark" {...props} />;
